<template>
    <div class="o-w-qr-generator w-qr-generator" ref="qr"/>
</template>

<script>
import qrcode from "qrcode-generator";
import { mapState } from "vuex";

export default {
    name: 'OWQrGenerator',
    computed: {
        ...mapState({
            mapId: state => state.map.id
        }),
        queryParameters() {
            return this.$route.query.from ? `?from=${this.$route.query.from}&to=${this.$route.query.to}` : `?to=${this.$route.query.to}&redirect-from=qr`
        }
    },
    mounted() {
        this.generateCode();
    },
    methods: {
        generateCode() {
            const typeNumber = 0;
            const errorCorrectionLevel = 'L';
            const qr = qrcode(typeNumber, errorCorrectionLevel);
            qr.addData(location.origin + '/' + `map-${this.mapId}/mobile/guide/${this.$route.params.type}` + this.queryParameters);
            qr.make();
            this.$refs.qr.innerHTML = qr.createSvgTag({ margin: 0});
        }
    }
}
</script>

<style lang="scss">
@import "o-w-qr-generator";
</style>
